//helpers/ConfiguratorHelper/EngineInputPreprocessor.ts
const prepareCurtainInputs = (inputs) => ({
    width: inputs.dimensions?.width || 119,
    height: inputs.dimensions?.height || 119,
    unit: inputs?.unit,
    fullness: Number(inputs?.fullness) || 2.5,
    hardware: {
        hardwareType: inputs.hardware?.hardwareType || 'MANUAL',
        motorizedType: inputs.hardware?.motorizedType,
        vendorId: inputs.hardware?.hardwareType !== 'NONE' ? (inputs.hardware?.vendor || inputs.hardware?.vendorId) : undefined,
    },
    liningType: inputs.liningType || 'NONE',
    thermalInterlining: Boolean(inputs.thermalInterlining),
    location: { country: inputs.location } || { country: 'IN' },
    quantity: inputs.quantity || 1,
    pairOrSingle: inputs.pairOrSingle,
    orientation: inputs.orientation,
    mountType: inputs.mountType,
    pleat: inputs.pleat
});

const prepareRomanBlindInputs = (inputs) => ({
    width: inputs.dimensions?.width || 80,
    height: inputs.dimensions?.height || 80,
    fullness: inputs.fullness || 1,
    unit: inputs?.unit,
    hardware: {
        hardwareType: inputs.hardware?.hardwareType || 'MANUAL',
        motorizedType: inputs.hardware?.motorizedType,
        vendorId: inputs.hardware?.hardwareType !== 'NONE' ? (inputs.hardware?.vendor || inputs.hardware?.vendorId) : undefined,
    },
    liningType: inputs.liningType || 'NONE',
    thermalInterlining: Boolean(inputs.thermalInterlining),
    location: { country: inputs.location } || { country: 'IN' },
    quantity: inputs.quantity || 1,
    mountType: inputs.mountType
});

const prepareRollerBlindInputs = (inputs) => ({
    width: inputs.dimensions?.width || 80,
    height: inputs.dimensions?.height || 80,
    quantity: inputs.quantity || 1,
    module: inputs.module || false,
    facia: inputs.facia || false,
    cassette: inputs.cassette || false,
    hardware: {
        hardwareType: inputs.hardware?.hardwareType || 'MANUAL',
        motorizedType: inputs.hardware?.motorizedType,
        vendorId: inputs.hardware?.hardwareType !== 'NONE' ? (inputs.hardware?.vendor || inputs.hardware?.vendorId) : undefined,
    },
    location: inputs.location || { country: 'IN' }
});

const prepareWoodenBlindInputs = (inputs) => ({
    width: inputs.dimensions?.width || 80,
    height: inputs.dimensions?.height || 80,
    quantity: inputs.quantity || 1,
    operatingSystem: inputs.operatingSystem || 'WEB',
    operationType: inputs.operationType || 'CORD_LOCK',
    hardware: {
        hardwareType: inputs.hardware?.hardwareType || 'MANUAL',
        motorizedType: inputs.hardware?.motorizedType,
        vendorId: inputs.hardware?.hardwareType !== 'NONE' ? (inputs.hardware?.vendor || inputs.hardware?.vendorId) : undefined,
    },
    location: inputs.location || { country: 'IN' }
});

const prepareCushionInputs = (inputs) => ({
    quantity: inputs.quantity || 1,
    selectedVariant: inputs.selectedVariant || '20x20',
    fabricPricePerInch: inputs.fabricPricePerInch,
    fillerPrice: inputs.fillerPrice,
    valueAdditionPricePerInch: inputs.valueAdditionPricePerInch,
    liningPricePerUnit: inputs.liningPricePerUnit,
    accessories: inputs.accessories || []
});

const prepareQuiltInputs = (inputs) => ({
    quantity: inputs.quantity || 1,
    selectedVariant: inputs.selectedVariant || 'QUEEN',
    fabricPricePerInch: inputs.fabricPricePerInch,
    borderFabricPricePerInch: inputs.borderFabricPricePerInch,
    fillerPrice: inputs.fillerPrice,
    valueAdditionPricePerInch: inputs.valueAdditionPricePerInch,
    liningPricePerUnit: inputs.liningPricePerUnit,
    accessories: inputs.accessories || []
});

const prepareUpholsteryInputs = (inputs) => ({
    quantity: inputs.quantity || 1,
    fabricPricePerInch: inputs.fabricPricePerInch
});

export const inputPreparers = {
    CURTAIN: prepareCurtainInputs,
    ROMAN_BLIND: prepareRomanBlindInputs,
    ROLLER_BLIND: prepareRollerBlindInputs,
    WOODEN_BLIND: prepareWoodenBlindInputs,
    CUSHION: prepareCushionInputs,
    QUILT: prepareQuiltInputs,
    UPHOLSTERY: prepareUpholsteryInputs
};
